import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const NotFoundPage: React.FC = () => {
  return (
    <div className="bg-gray-50 py-16">
      <SEO 
        title="Page Not Found"
        description="The page you're looking for doesn't exist or has been moved."
        image="/og-image.png"
        imageAlt="GoodCart - Page Not Found"
        url="https://goodcart.org/404"
        type="website"
        locale="en_US"
        siteName="GoodCart"
      />
      
      <div className="container-custom">
        <div className="max-w-md mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="text-brand-green-500 mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Page Not Found</h1>
            
            <p className="text-gray-600 mb-8">
              Oops! The page you're looking for doesn't exist or has been moved.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/" className="btn btn-primary">
                Go to Homepage
              </Link>
              <Link to="/search" className="btn btn-outline">
                Browse Products
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;